import { messages as adminCarMessages } from '../views/car/adminCarLang'
import { messages as adminCarInoutMessages } from '../views/iot/adminCarInoutLang'
import { messages as parkingAreaManageMessages } from '../views/car/parkingAreaManageLang'
import { messages as listParkingSpaceMessages } from '../views/car/listParkingSpaceLang'
import { messages as parkingBoxManageMessages } from '../views/car/parkingBoxManageLang'
import { messages as listOwnerCarMessages } from '../views/car/listOwnerCarLang'
import { messages as hireParkingSpaceMessages } from '../views/car/hireParkingSpaceLang'
import { messages as carAddParkingSpaceMessages } from '../views/car/carAddParkingSpaceLang'
import { messages as buyCarMonthCardMessages } from '../views/fee/buyCarMonthCardLang'
import { messages as carInoutManageMessages } from '../views/car/carInoutManageLang'
import { messages as carInManageMessages } from '../views/car/carInManageLang'
import { messages as remainingParkingSpaceMessages } from '../views/car/remainingParkingSpaceLang'
import { messages as tempCarPaymentMessages } from '../views/car/tempCarPaymentLang'
import { messages as parkingSpaceApplyManageMessages } from '../views/car/parkingSpaceApplyManageLang'
import { messages as addParkingSpaceApplyMessages } from '../views/car/addParkingSpaceApplyLang'
import { messages as auditParkingSpaceApplyMessages } from '../views/car/auditParkingSpaceApplyLang'
import { messages as carDetailMessages } from '../views/car/carDetailLang.js'

export const messages = {
    en: {
        ...adminCarMessages.en,
        ...adminCarInoutMessages.en,
        ...parkingAreaManageMessages.en,
        ...listParkingSpaceMessages.en,
        ...parkingBoxManageMessages.en,
        ...listOwnerCarMessages.en,
        ...hireParkingSpaceMessages.en,
        ...carAddParkingSpaceMessages.en,
        ...buyCarMonthCardMessages.en,
        ...carInoutManageMessages.en,
        ...carInManageMessages.en,
        ...remainingParkingSpaceMessages.en,
        ...tempCarPaymentMessages.en,
        ...parkingSpaceApplyManageMessages.en,
        ...addParkingSpaceApplyMessages.en,
        ...auditParkingSpaceApplyMessages.en,
        ...carDetailMessages.en,
    },
    zh: {
        ...adminCarMessages.zh,
        ...adminCarInoutMessages.zh,
        ...parkingAreaManageMessages.zh,
        ...listParkingSpaceMessages.zh,
        ...parkingBoxManageMessages.zh,
        ...listOwnerCarMessages.zh,
        ...hireParkingSpaceMessages.zh,
        ...carAddParkingSpaceMessages.zh,
        ...buyCarMonthCardMessages.zh,
        ...carInoutManageMessages.zh,
        ...carInManageMessages.zh,
        ...remainingParkingSpaceMessages.zh,
        ...tempCarPaymentMessages.zh,
        ...parkingSpaceApplyManageMessages.zh,
        ...addParkingSpaceApplyMessages.zh,
        ...auditParkingSpaceApplyMessages.zh,
        ...carDetailMessages.zh,
    }
}